import React from 'react'
import { hooks } from 'botframework-webchat-component'
import type { POIContentType } from '../../models/attachmentTypes'
import { PhotoCameraIcon, FavoriteLightIcon } from '../Icons/DetailedPOIIcons'
import CommentsPennantMini from './DetailedAttachment/CommentsPennantMini'
import { useView } from '../Contexts/ViewContext'

const { useSendPostBack } = hooks

const ReviewsAndFavorite = ({ reviews, favorite }): JSX.Element => {
  return (
    <React.Fragment>
      {reviews && (
        <CommentsPennantMini
          customerReviews={reviews}
          className='rf-absolute rf-top-0 rf-right-2'
        />
      )}
      {favorite && (
        <FavoriteLightIcon className='rf-absolute rf-h-6 large:rf-h-8 rf-bottom-2 rf-right-2' />
      )}
    </React.Fragment>
  )
}

const POIAttachment = ({
  media,
  title,
  subtitle,
  favorite,
  customerReviews,
  tap
}: POIContentType): JSX.Element => {
  const sendPostBack = useSendPostBack()
  const { themeColors } = useView()

  const handleClick = (): void => {
    tap && sendPostBack(tap)
  }

  return (
    <div
      className='rf-w-full rf-h-full rf-flex rf-flex-col rf-rounded hover:rf-cursor-pointer'
      onClick={handleClick}
    >
      {media && media[0]?.url ? (
        <div
          className='rf-relative rf-w-full rf-rounded rf-aspect-video'
          style={{
            backgroundImage: `url(${media[0].url})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center'
          }}
        >
          <ReviewsAndFavorite reviews={customerReviews} favorite={favorite} />
        </div>
      ) : (
        <div className='rf-relative rf-w-full rf-bg-silver rf-rounded rf-aspect-video'>
          <PhotoCameraIcon className='rf-absolute rf-h-1/3 rf-top-1/3 rf-left-1/2 rf-transform -rf-translate-x-1/2' />
          <ReviewsAndFavorite reviews={customerReviews} favorite={favorite} />
        </div>
      )}

      {/* Subtitle 2 lines max / title 2 lines max */}
      {subtitle && (
        <p
          className='rf-mt-2 rf-font-bold rf-line-clamp-2'
          style={{
            color: themeColors.agendaColor
          }}
        >
          {subtitle}
        </p>
      )}
      <p className='rf-my-2 rf-font-bold rf-line-clamp-2'>{title || ''}</p>
    </div>
  )
}

export default POIAttachment
